import { render, staticRenderFns } from "./work.vue?vue&type=template&id=700cb966&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"
import style0 from "./work.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./work.vue?vue&type=style&index=1&id=700cb966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700cb966",
  null
  
)

export default component.exports